import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '.js-geo-data',
			inited: '.js-geo-data-inited'
		};
		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		return this;
	}

	prepare(json) {
		const data = {};
		$.each(json, function (key, val) {
			data[key.toLowerCase()] = val;
		});
		return data;
	}

	setData() {
		const self = this;
		self.$el = $(this.options.el + ':not(' + this.options.inited + ')');
		if (self.$el.length) {
			self.$el.each(function () {
				const $geo = $(this);
				const type = $geo.data('type').toLowerCase();
				if (typeof self.data[type] != 'undefined') {
					let set = self.data[type];
					set = set.replace(/\./g, ',');
					$geo
						.addClass('js-geo-data-inited')
						.text(set);
				}
			});
		}
		return self;
	}

	render() {
		const self = this;

		if (yotaPortlets.geo) {
			self.data = self.prepare(yotaPortlets.geo);
		} else {
			console.error('The GEO content has no data, set data to "yotaPortlets.geo"');
		}

		if (self.$el.length) {
			self.setData();
		}

		setInterval(function () {
			self.setData();
		}, 1000);
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/blocks/geo/geo.js